import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PendingApprovalButtonI18nHeading from '../i18n/PendingApprovalButtonI18nHeading';
import PendingApprovalButtonI18nTitle from '../i18n/PendingApprovalButtonI18nTitle';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButton(props) {
  const {
    buttonProps,
    tooltipProps
  } = props;
  const {
    isUserStepPending,
    isApprover,
    isPending
  } = useApprovalConditions();
  if (!isPending) {
    return null;
  }
  if (isApprover && isUserStepPending) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    "data-test-id": "pending-approval-button-tooltip",
    use: "longform",
    placement: "bottom"
  }, tooltipProps, {
    headingText: /*#__PURE__*/_jsx(PendingApprovalButtonI18nHeading, {}),
    title: /*#__PURE__*/_jsx(PendingApprovalButtonI18nTitle, {}),
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.pendingApproval"
      })
    }))
  }));
}
export default PendingApprovalButton;